import { DateType } from "./data";

export const formatMonthOrDay = (mod: number): string =>
  mod < 10 ? `0${mod}` : `${mod}`;

export const formatDate = (date: DateType): number =>
  parseInt(
    `${date.year}${formatMonthOrDay(date.month)}${formatMonthOrDay(date.day)}`
  );
